<template>
  <div>
    <div
      style="position: absolute;top: 50%; left: 52%; width: 10%; z-index: 2;"
      v-show="loadData == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div :class="showDialogConfirm ? 'bg-backdrop-set-config' : ''"></div>

    <md-dialog
      :md-active.sync="value"
      class="mkt-ops -main-font set-config-vd"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title
        >Change of person in charge "Volume Discount"</md-dialog-title
      >

      <div class="dialog-content">
        <div class="search-user">
          <div class="account-code" style="margin-right: 40px;">
            <label style="margin-left: 10px; font-weight: 400;"
              >User account code</label
            >
            <multiselect
              v-model="selectedUserAccountCode"
              label="firstname"
              track-by="code"
              placeholder="User account code"
              :open-direction="'bottom'"
              :options="dpUserAccount"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelUserAccount"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataUserAccountCode"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div
                    class="-label"
                    style="font-family: kanit; padding-top: 3px;"
                  >
                    {{ option.firstname }} {{ option.lastname }}
                  </div>
                  <div
                    class="-delete"
                    style="padding-top: 2px; margin-right: 8px;"
                    @mousedown.prevent.stop="clearUserAccountCode(option.code)"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div style="display: grid;" v-show="isEdit">
            <label style="padding-top: 7px; font-weight: bold; color: #3f51b5;"
              >Move to</label
            >
            <md-icon style="padding-bottom: 5px;"
              ><span style="font-size: 32px; color: #3f51b5;"
                >arrow_right_alt</span
              ></md-icon
            >
          </div>

          <div
            class="account-change"
            style="margin-left: 40px;"
            v-show="isEdit"
          >
            <label style="margin-left: 10px; font-weight: 400;"
              >User account change new</label
            >
            <multiselect
              v-model="selectedUserAccountChange"
              label="firstname"
              track-by="code"
              placeholder="User account change new"
              :open-direction="'bottom'"
              :options="dpUserAccount"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelUserAccount"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataUserAccountChange"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div
                    class="-label"
                    style="font-family: kanit; padding-top: 3px;"
                  >
                    {{ option.firstname }} {{ option.lastname }}
                  </div>
                  <div
                    class="-delete"
                    style="padding-top: 2px; margin-right: 8px;"
                    @mousedown.prevent.stop="
                      clearUserAccountChange(option.code)
                    "
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <!-- TABLE -->
        <div id="table-volume-discount">
          <div id="divHeadList">
            <div style="width: 5%;" v-show="isEdit">
              <label class="-mkt-checkbox-container">
                <input
                  type="checkbox"
                  @click="selectAllProductFilter"
                  v-model="checkedProductFilterAll"
                />
                <span class="-mkt-checkbox"></span>
              </label>
            </div>
            <div style="width: 18%;">Code</div>
            <div :style="isEdit ? 'width: 36.5%' : 'width: 41.5%'">Title</div>
            <div style="width: 12%">Type</div>
            <div style="width: 16%">Create By</div>
            <div style="width: 12.5%;">Create Date</div>
          </div>
          <div id="divBodyList">
            <div
              v-show="tableVD.length === 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center; font-size: 14px;"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray -pointer'"
              v-for="(item, rIndex) in tableVD"
              :key="rIndex"
            >
              <div style="width: 5%;" v-show="isEdit">
                <label class="-mkt-checkbox-container">
                  <input
                    type="checkbox"
                    v-model="checkedProductFilter"
                    :id="item.code"
                    :value="item.code"
                    @click="selectProductFilter(item.code)"
                  />
                  <span class="-mkt-checkbox"></span>
                </label>
              </div>
              <div style="width: 18%;" class="nowrap-title -font-kanit">
                <span :title="item.code">{{ item.code }}</span>
              </div>
              <div
                :style="isEdit ? 'width: 36.5%' : 'width: 41.5%;'"
                class="nowrap-title -font-kanit"
              >
                <span
                  :title="item.h_name"
                  :style="isEdit ? '' : 'padding-left: 5px;'"
                  >{{ item.h_name }}</span
                >
              </div>
              <div style="width: 12%;" class="-font-kanit">
                {{ item.type }}
              </div>
              <div style="width: 16%;" class="-font-kanit">
                {{ item.displayname }}
              </div>
              <div style="width: 12.5%;">
                {{ formatDate(item.c_date) }}
              </div>
            </div>
          </div>
          <div class="footer-table">
            number of lines in page ({{ tableVD.length }})
          </div>
        </div>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="onClickCancel()"
          >CANCEL</md-button
        >
        <md-button
          v-show="isEdit"
          class="md-primary -update"
          @click="onClickUpdate()"
          >UPDATE DATA</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      class="dialog-confirm-set-config"
      :md-active.sync="confirmChange"
      :md-title="titleConfirm"
      :md-content="textConfirm"
      :md-confirm-text="textBtnConfirm"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import SettingService from "@/services/setting";
import moment from "moment-timezone";
import Vue from "vue";

export default {
  name: "set-config-vd",
  props: ["value", "dpUserAccount"],
  components: {},
  created() {},
  watch: {},
  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isEdit() {
      return this.permit.acl["setting"].menus["set-config"].edit;
    }
  },
  data() {
    return {
      loadData: false,
      selectedUserAccountCode: [],
      // optionsUserAccountCode: [],
      selectedUserAccountChange: [],
      // optionsUserAccountChange: [],
      userCode: "",
      userChange: "",
      tableVD: [],
      checkedProductFilter: [],
      checkedProductFilterAll: false,
      confirmChange: false,
      titleConfirm: "Confirm ?",
      textConfirm: "",
      textBtnConfirm: "",
      checkConfirm: "",
      showDialogConfirm: false,
      showSnackbar: false,
      dContent: "",
      position: "center",
      duration: 20000,
      isInfinity: false
    };
  },
  mounted() {},
  methods: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    selectAllProductFilter() {
      this.checkedProductFilter = [];
      if (!this.checkedProductFilterAll) {
        for (let i in this.tableVD) {
          this.checkedProductFilter.push(this.tableVD[i].code);
        }
      }
    },
    selectProductFilter(id) {
      if (this.checkedProductFilter.indexOf(id) == -1) {
        this.checkedProductFilter.push(id);
      } else {
        this.checkedProductFilter.splice(
          this.checkedProductFilter.indexOf(id),
          1
        );
      }
    },
    onClickCancel() {
      if (!this.isEdit) {
        this.selectedUserAccountCode = [];
        this.selectedUserAccountChange = [];
        this.tableVD = [];
        this.checkedProductFilter = [];
        this.checkedProductFilterAll = false;
        this.userCode = "";
        this.userChange = "";
        this.$emit("clickCancel");
      } else {
        this.titleConfirm = "";
        this.textConfirm = "Are you sure you want to cancel changes ?";
        this.textBtnConfirm = "OK";
        this.confirmChange = true;
        this.checkConfirm = "cancel";
        this.showDialogConfirm = true;
      }
    },
    onClickUpdate() {
      if (this.userCode === "") {
        this.dContent = "Please select User account code";
        this.showSnackbar = true;
        return false;
      } else if (this.userChange === "") {
        this.dContent = "Please select User account change new";
        this.showSnackbar = true;
        return false;
      } else if (this.checkedProductFilter.length === 0) {
        this.dContent = "Please select data for update.";
        this.showSnackbar = true;
        return false;
      } else {
        this.titleConfirm = "Confirm ?";
        this.textConfirm = "Are you sure you want to update ?";
        this.textBtnConfirm = "sure";
        this.confirmChange = true;
        this.checkConfirm = "update";
        this.showDialogConfirm = true;
      }
    },
    customLabelUserAccount({ firstname, lastname }) {
      return `${firstname} ${lastname}`;
    },
    setDataUserAccountCode(selectedOption) {
      this.userCode = selectedOption.code;
      this.loadData = true;

      let datas = { menu: "discount", code: selectedOption.code };
      SettingService.getConfigListPromotionVD(datas).then(response => {
        if (response && response.data.length > 0) {
          this.tableVD = response.data;
        } else {
          this.tableVD = [];
        }
        this.loadData = false;
      });
    },
    setDataUserAccountChange(selectedOption) {
      this.userChange = selectedOption.code;
    },
    clearUserAccountCode(code, type) {
      this.selectedUserAccountCode = [];
      this.tableVD = [];
      this.userCode = "";
    },
    clearUserAccountChange(code, type) {
      this.selectedUserAccountChange = [];
      this.userChange = "";
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkConfirm === "cancel") {
        this.selectedUserAccountCode = [];
        this.selectedUserAccountChange = [];
        this.tableVD = [];
        this.checkedProductFilter = [];
        this.checkedProductFilterAll = false;
        this.userCode = "";
        this.userChange = "";
        this.$emit("clickCancel");
      } else if (this.checkConfirm === "update") {
        this.loadData = true;
        let user = Vue.$jwt.decode(localStorage.getItem("token"));
        let chaeckall =
          this.checkedProductFilter.length === this.tableVD.length
            ? true
            : false;
        let dataSave = {
          user: this.userCode,
          new_user: this.userChange,
          update_by: user.code,
          all: chaeckall,
          select: chaeckall ? [] : this.checkedProductFilter
        };
        // console.log("dataSave ==>", dataSave);
        SettingService.updateConfigChangeCreateby("discount", dataSave).then(
          response => {
            // console.log("response ==>", response);
            this.loadData = false;
            this.selectedUserAccountCode = [];
            this.selectedUserAccountChange = [];
            this.tableVD = [];
            this.checkedProductFilter = [];
            this.checkedProductFilterAll = false;
            this.userCode = "";
            this.userChange = "";
            this.$emit("clickUpdate");
          }
        );
      }
      this.showDialogConfirm = false;
    }
  },
  beforeDestroy() {}
};
</script>
